import * as Sentry from "@sentry/browser";
import Rails from "@rails/ujs";
import * as ClipboardJS from 'clipboard';
import * as bootstrap from 'bootstrap/dist/js/bootstrap';
import * as echarts from 'echarts';
import 'src/popup_notifications';

window.echarts = echarts;

if (process.env.SENTRY_JS_DSN) {
  Sentry.init({
    dsn: process.env.SENTRY_JS_DSN,
    environment: process.env.SENTRY_ENVIRONMENT || 'production',
  });
}

Rails.start();

// Clipboard copy button
document.addEventListener("DOMContentLoaded", function() {
  const clipboard = new ClipboardJS('.btn');
  clipboard.on('success', (e) => {
    const copyButtonDom = e.trigger;
    const tooltip = bootstrap.Tooltip.getOrCreateInstance(copyButtonDom, {
      title: 'コピーしました'
    });
    copyButtonDom.addEventListener('shown.bs.tooltip', (e) => {
      tooltip.disable();
    });
    tooltip.enable();
    tooltip.show();
  });
});

// Generic tooltip
// https://getbootstrap.com/docs/5.0/components/tooltips/#example-enable-tooltips-everywhere
document.addEventListener("DOMContentLoaded", function() {
  const tooltipTriggerList = [].slice.call(document.querySelectorAll('[data-bs-toggle="tooltip"]'))
  const tooltipList = tooltipTriggerList.map(function (tooltipTriggerEl) {
    return new bootstrap.Tooltip(tooltipTriggerEl)
  });
});

// Support component names relative to this directory:
var componentRequireContext = require.context("components", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);
